import React from 'react'
import Navbar from '../components/navbar/Navbar'
import Header from '../containers/header/Header'  
import Services from '../containers/brand/Brand'
import WhatGPT3 from '../containers/whatGPT3/WhatGPT3' 
import Features from '../containers/features/Features'
import Possibility from '../containers/possibility/Possibility'
import CTA from '../components/cta/CTA'
import Blog from '../containers/blog/Blog'
import Footer from '../containers/footer/Footer'
import WhatsappIcon from './WhatsappIcon'
const Home = () => {
  return (
    <>
    <div className="gradient__bg">
      <Navbar />
      <Header />
    </div>
    <Services />
    <WhatGPT3 />
    <Features />
    <Possibility />
    <CTA />
    <Blog />
    <Footer />
    <WhatsappIcon/>
    </>
  )
}

export default Home